import Svg, { SvgProps, Circle } from 'react-native-svg';
import { memo } from 'react';
const SvgComponent = (props: SvgProps) => (
  <Svg viewBox="0 0 36 36" {...props}>
    <Circle cx={18} cy={18} r={18} />
  </Svg>
);
const Memo = memo(SvgComponent);
export default Memo;
